import { render, staticRenderFns } from "./OrderManagement.vue?vue&type=template&id=26a86490&scoped=true&"
import script from "./OrderManagement.vue?vue&type=script&lang=js&"
export * from "./OrderManagement.vue?vue&type=script&lang=js&"
import style0 from "./OrderManagement.vue?vue&type=style&index=0&id=26a86490&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a86490",
  null
  
)

export default component.exports